export default {
    ca: {
        title: 'Descarregar una capa',
        desc: 'Escull una capa per descarregar:',
    },
    es: {
        title: 'Descargar una capa',
        desc: 'Escoge una capa para descargar:',
    },
    en: {
        title: 'Download layer',
        desc: 'Choose a layer to download:',
    },
};



// WEBPACK FOOTER //
// ./src/map-viewer/components/downloadlayers-modal/downloadlayers-modal-translations.js